/* eslint-disable no-throw-literal */
/* eslint-disable react-hooks/exhaustive-deps */
import { useImmer } from "use-immer";
import { useDropdownApis } from "../../../shared";
import { arraySort, errorMessage, successMessage } from "../../../utils";
import { exportPlAndBsReportApi, getPLReport } from "../../List";
import React from "react";
import qs from "qs";
import SimpleReactValidator from "simple-react-validator";
import { AppContext, AuthContext } from "../../../store";
import { useLocation } from "react-router-dom";
const fileDownload = require("js-file-download");

const defaultFilter = {
  options: {
    stores: [],
    financialYears: [],
    accountMonths: [],
  },
  values: { store: [], financialYear: null, month: [] },
  appliedFilters: [],
  isFilterApplied: true,
};

export const usePLReport = () => {
  const { appState } = React.useContext(AppContext);
  const { globalData, currentTabs } = appState;
  const { auth } = React.useContext(AuthContext);
  const [, forceUpdate] = React.useState();
  const location = useLocation();
  const isStoreAdmin = location.pathname.includes("store-admin");
  const [state, setState] = useImmer({
    isBusy: false,
    data: [],
    column: [],
    isApply: false,
    filterApplied: {
      all: [],
      store_id: [],
      year: {},
      month: [],
    },
    hideReport: true,
    filter: {
      options: {
        stores: [],
        financialYears: [],
        accountMonths: [],
      },
      values: { store: [], financialYear: null, month: [] },
      appliedFilters: [],
      isFilterApplied: true,
    },
  });

  const validator = React.useRef(
    new SimpleReactValidator({
      autoForceUpdate: { forceUpdate: forceUpdate },
      element: (message) => message,
    })
  );

  const { franchiseeWiseStoreList } = useDropdownApis({
    isFranchiseeWiseStoreList: !isStoreAdmin && currentTabs.plAndbs === "1",
  });

  const savePLReport = async ({ params }) => {
    triggerApplyButtonLoading(true);
    try {
      const query = {
        params,
        paramsSerializer: (params) => qs.stringify(params),
      };

      const response = await getPLReport(query);
      if (response?.data) {
        successMessage("Created Successfully");
        setState((draft) => {
          draft.data = response.data;
          draft.column = response.headers;
          draft.filter.isFilterApplied = true;
          draft.hideReport = false;
        });
      } else {
        setState((draft) => {
          draft.data = [];
          draft.column = [];
          draft.filter.isFilterApplied = true;
          draft.hideReport = false;
        });
        throw {
          response: {
            data: { message: response?.message ?? "Report is not available." },
          },
        };
      }
    } catch (err) {
      const message = err.response.data.message;
      errorMessage(message);
    } finally {
      triggerApplyButtonLoading(false);
    }
  };

  // ===================================================== New Filter =================================================
  const triggerApplyButtonLoading = (loading) => {
    setState((draft) => {
      draft.isBusy = loading;
    });
  };

  const exportPlReport = async ({ reportType, params }) => {
    try {
      const response = await exportPlAndBsReportApi({ reportType, params });

      if (response.status === 200) {
        let fileName = "ProfitAndLossReport";
        const contentType = response.headers["content-type"];
        fileDownload(response.data, fileName, contentType);
      } else {
        throw {
          response: { data: { message: "Failed to export the report" } },
        };
      }
    } catch (error) {
      const message =
        error.response?.data?.message || "Failed to export the report";
      errorMessage(message);
    }
  };

  const convertFilterToAppliedFilter = (appliedFilter) => {
    const filters = [];
    Object.entries(appliedFilter).forEach(([key, value]) => {
      if (value?.label)
        filters.push({
          type: key.replace(key[0], key[0].toUpperCase()),
          label: value.label,
          accessorKey: key,
        });
      else if (Array.isArray(value)) {
        value?.forEach((item) => {
          filters.push({
            type: key.replace(key[0], key[0].toUpperCase()),
            label: item.label,
            accessorKey: key,
          });
        });
      }
    });

    return filters;
  };

  const handleChangeFilter = ({ name, value }) => {
    setState((draft) => {
      draft.filter.values[name] = value;
      draft.filter.isFilterApplied = false;
    });
  };

  const getFilterParams = async (filterValues) => {
    let params = {};
    Object.entries(filterValues).forEach(([key, value]) => {
      const actualKey =
        key === "store" ? "store_id" : key === "financialYear" ? "year" : key;
      params = {
        ...params,
        [actualKey]: Array.isArray(value)
          ? value.map((v) => v.value)
          : value?.value,
      };
    });

    if (isStoreAdmin && auth?.data?.selectedStoreId) {
      params.store_id = [auth.data.selectedStoreId];
    }
    return params;
  };

  const handleFilterApply = async () => {
    if (
      validator.current.allValid() ||
      (isStoreAdmin &&
        validator.current.fieldValid("Financial year") &&
        validator.current.fieldValid("Month"))
    ) {
      const params = await getFilterParams(state.filter.values);

      await savePLReport({ params });
    } else {
      validator.current.showMessages();
      forceUpdate(1);
    }
  };

  const handleClearFilter = async (item) => {
    const values = state.filter.values[item.accessorKey];
    handleChangeFilter({
      name: item.accessorKey,
      value: Array.isArray(values)
        ? values.filter((value) => value.label !== item.label)
        : null,
    });
  };

  const handleClearAllFilter = async () => {
    setState((draft) => {
      draft.filter.appliedFilters = defaultFilter.appliedFilters;
      draft.filter.values = defaultFilter.values;
      draft.filter.isFilterApplied = true;
      draft.data = [];
      draft.hideReport = true;
    });

    validator.current.hideMessages();
    forceUpdate(0);
  };

  const handleReportExport = async ({ reportType }) => {
    const params = await getFilterParams(state.filter.values);
    await exportPlReport({
      reportType,
      params,
    });
  };

  React.useEffect(() => {
    setState((draft) => {
      const accountMonthList = globalData?.pl_bs_reports?.pl_bs_accounts_months;
      const financialYearList = globalData?.pl_bs_reports?.pl_bs_accounts_years;

      if (accountMonthList) {
        const months = accountMonthList.map((month) => {
          const updatedMonth = {
            ...month,

            quarter:
              month.value <= 3
                ? "Q1"
                : month.value <= 6
                ? "Q2"
                : month.value <= 9
                ? "Q3"
                : "Q4",
          };

          return updatedMonth;
        });

        draft.filter.options.accountMonths = months;
      }
      if (financialYearList) {
        const years = financialYearList;
        draft.filter.options.financialYears = years;
      }
    });
  }, [globalData]);

  React.useEffect(() => {
    if (franchiseeWiseStoreList && !isStoreAdmin) {
      const stores = [
        ...franchiseeWiseStoreList.map((store) => ({
          label: store.name,
          value: store.id,
          franchisee_id: store.franchisee_id,
          franchisee_name: store.franchisee_name,
        })),
      ];
      setState((draft) => {
        if (stores.length > 0) {
          draft.filter.options.stores = arraySort(stores, "franchisee_name");
        }
      });
    }
  }, [franchiseeWiseStoreList]);

  React.useEffect(() => {
    setState((draft) => {
      draft.filter.appliedFilters = convertFilterToAppliedFilter(
        state.filter.values
      );
    });
  }, [state.filter.values]);

  return {
    state,
    validator,
    currentTabs,
    // storeList,
    // onChange,
    // onSavePLReport,
    // handleApplyFilter,
    // handleFilterClear,
    // globalData,
    // setCurentTab,
    // currentTab,
    // New Filter Handlers
    handleChangeFilter,
    handleFilterApply,
    handleClearAllFilter,
    handleClearFilter,
    handleReportExport,
  };
};

// const onSavePLReport = async ({ store_id, month, year }) => {
//   try {
//     setState((draft) => {
//       draft.isSaveButtonBusy = true;
//     });
//     let params = {};

//     if (store_id?.length > 0) {
//       let IDs = store_id.map((v) => {
//         return v.value;
//       });
//       params = { ...params, store_id: IDs };
//     }
//     if (toString(year.value)) {
//       params = { ...params, year: year.value };
//     }
//     if (month?.length > 0) {
//       let IDs = month.map((v) => {
//         return v.value;
//       });
//       params = { ...params, month: IDs };
//     }
//     const query = {
//       params,
//       paramsSerializer: (params) => qs.stringify(params),
//     };
//     const res = await getPLReport(query);
//     if (res?.data.length) {
//       successMessage("Created Successfully");
//       setState((draft) => {
//         draft.data = res.data;
//         draft.column = res.headers;
//         draft.isSaveButtonBusy = false;
//       });
//     } else {
//       errorMessage("Report is not available.");
//       setState((draft) => {
//         draft.data = [];
//         draft.isSaveButtonBusy = false;
//       });
//     }
//   } catch (err) {
//     errorMessage(err.response.data.message);
//     setState((draft) => {
//       draft.isSaveButtonBusy = false;
//     });
//   }
// };

// const onChange = (e, value, type) => {
//   if (type === "store") {
//     setState((draft) => {
//       draft.filterApplied.store_id = value.map((v) => {
//         return { ...v, type: "Store" };
//       });
//     });
//   } else if (type === "year") {
//     setState((draft) => {
//       draft.filterApplied.year = {
//         value: value.value,
//         label: value.label,
//         type: "Year",
//       };
//     });
//   }
//   if (type === "month") {
//     setState((draft) => {
//       draft.filterApplied.month = value.map((v) => {
//         return { ...v, type: "Month" };
//       });
//     });
//     setState((draft) => {
//       draft.disableApplyButton = false;
//     });
//   }
// };

// useEffect(() => {
//   setState((draft) => {
//     draft.filterApplied.all = [
//       ...state?.filterApplied?.store_id,
//       ...state?.filterApplied?.month,
//       state?.filterApplied?.year,
//     ].filter((el) => Object.keys(el).length);
//   });
// }, [
//   state.filterApplied.store_id,
//   state.filterApplied.month,
//   state.filterApplied.year,
// ]);

// const handleApplyFilter = () => {
//   setState((draft) => {
//     draft.isApply = true;
//   });
//   const { store_id, month, year } = state.filterApplied;
//   if (validator.current.allValid()) {
//     onSavePLReport({ store_id, month, year });
//   } else {
//     validator.current.showMessages();
//     forceUpdate(1);
//   }
// };

// const handleFilterClear = (type, value) => {
//   if (type === "single") {
//     if (value.type === "Store") {
//       const filteredStores = state.filterApplied.store_id.filter(
//         (e) => e.value !== value.value
//       );
//       setState((draft) => {
//         draft.filterApplied.store_id = filteredStores;
//       });
//     }
//     if (value.type === "Month") {
//       const filteredStores = state.filterApplied.month.filter(
//         (e) => e.value !== value.value
//       );
//       setState((draft) => {
//         draft.filterApplied.month = filteredStores;
//       });
//     } else if (value.type === "Year") {
//       setState((draft) => {
//         draft.filterApplied.year = {};
//       });
//     }
//   } else {
//     setState((draft) => {
//       draft.filterApplied.all = [];
//       draft.filterApplied.store_id = [];
//       draft.filterApplied.month = [];
//       draft.filterApplied.year = {};
//       draft.isApply = false;
//     });
//   }
// };
